module.exports = __webpack_public_path__ + "img/icon-dollar.dfcbd8d7.svg";